import Repository from '@/repositories/marketing'
const resource = '/coupon_banks'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    create(data){
        return Repository.post(`${resource}.json`,data)
    },    
    edit(data,id){
        return Repository.put(`${resource}/${id}.json`,data)
    },
    export(data,id){
        return Repository.post(`${resource}/${id}/export.json`,data)
    },
    importFile(data,id){
        return Repository.post(`${resource}/${id}/import_csv.json`,data)
    },
    importFtp(data,id){
        return Repository.post(`${resource}/${id}/import_ftp.json`,data)
    },
    getRefreshCount(id){
        return Repository.get(`${resource}/${id}/refresh_count.json`)
    },
    getFileOptions(config){
        return Repository.get(`/ftp_import_file_options.json`, config)
    },
    getCouponBanksById(id){
        return Repository.get(`${resource}/${id}.json`)
    },
}